import * as apiTo from '@/modular-api'
import pluralize from 'pluralize'

const findLabel = (labels, entityName) => {
  for (const [index, label] of labels.entries()) {
    if (label.entity_name === entityName) {
      return { index, label }
    }
  }

  return { index: -1, label: null }
}

const pluralOrSingularLabel = (state, filter, pluralOrSingular) => {
  if (!['plural', 'singular'].includes(pluralOrSingular)) {
    throw new Error(`pluralOrSingular variable should equal plural or singular`)
  }

  const label = findLabel(state.labels, filter).label
  const userLabel = label.user_label

  return {
    id: label.id,
    label: userLabel,
    entity: label.entity_name,
    singular: pluralize.singular(userLabel),
    plural: pluralize(userLabel)
  }
}

export default {
  namespaced: true,

  state: () => ({
    labels: null
  }),

  getters: {
    departmentLabel: state => pluralOrSingularLabel(state, 'Departments', 'singular'),
    costCenterLabel: state => pluralOrSingularLabel(state, 'Cost centers', 'plural')
  },

  mutations: {
    setLabels: (state, payload) => (state.labels = payload),
    updateLabel(state, newLabel) {
      const { index } = findLabel(state.labels, newLabel.entity_name)

      if (~index) state.labels.splice(index, 1, newLabel)
    }
  },

  actions: {
    getAndSetEntities({ commit }) {
      return apiTo.GET_ENTITY_LABELS().then(({ data }) => {
        commit('setLabels', data.result)
        return data.result
      })
    },

    updateEntityLabel({ commit }, { label, newName }) {
      return apiTo.MODIFY_ENTITY_LABEL(label.id, { user_label: newName }).then(({ data }) => {
        commit('updateLabel', data.result)
        return data.result
      })
    }
  }
}
